var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1920 240",
    width: 1920,
    height: 240,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1920,
    height: 240,
    fill: "#14141F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 198L64 171.5C128 145 256 92 384 78.2C512 64.3 640 89.7 768 116.5C896 143.3 1024 171.7 1152 182.3C1280 193 1408 186 1536 164.5C1664 143 1792 107 1856 89L1920 71",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    stroke: "#56c7fc",
    strokeWidth: 40
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWave);
export default __webpack_public_path__ + "static/media/blue-wave.858bb8279c07cbefaff7c7ebdc3cee5d.svg";
export { ForwardRef as ReactComponent };